import { UserDataAdapter } from "../../presentation/adpters/UserDataAdapter";
import { LocalStoreService } from "../../presentation/services/LocalStoreService";

export class FetchClient {
    LocalStoreService = new LocalStoreService();
    constructor() {
        this.user = new UserDataAdapter().user();
        this.jwtToken = this.LocalStoreService.getItem("nucont:jwt_token");
    }

    async call(url, params = {}, configs = {}) {
        const headers = new Headers({
            "Content-Type": "application/json",
            "user-id": configs.userId || this.user?._id || "",
            authorization: `Bearer ${configs.token || this.jwtToken}`
        });
        try {
            const response = await fetch(url, {
                body: JSON.stringify(params),
                headers,
                method: "POST"
            });
            return response.json();
        } catch (error) {
            throw new Error(error);
        }
    }
}
